import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const APPLICATION_CREATE_RESOURCE = "application" as const;
export const APPLICATION_CREATE_API_PATH = `/v1/${APPLICATION_CREATE_RESOURCE}` as const;

export type ApplicationCreateBody =
  paths[typeof APPLICATION_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type ApplicationCreateResponse =
  paths[typeof APPLICATION_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useApplicationCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApplicationCreateResponse, Error, ApplicationCreateBody>({
    mutationFn: async (application: ApplicationCreateBody) => {
      const response = await alphartisApiAxios.post<ApplicationCreateResponse>(
        APPLICATION_CREATE_API_PATH,
        application,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [APPLICATION_CREATE_RESOURCE],
      });
    },
  });
};
